export const licence = {
  updateLicence: {
    url: "admin/application/updateLicense/",
    method: "PUT",
    data: null,
    id: null,
  },
};
